<template>
    <div class="m-contactlistingcard">
        <div class="inner">
            <div class="e-initials">
                <span>
                    {{resultItem.Content.StaffInitials}}
                </span>
            </div>
            <div class="e-text">
                <h3>{{resultItem.Content.StaffFirstName}} {{resultItem.Content.StaffLastName}}</h3>
                <p class="title">{{resultItem.Content.StaffJobTitle}}</p>

                <p v-if="resultItem.Content.JobDescription">
                    Contact me for: {{resultItem.Content.StaffJobDescription}}
                </p>

                <p v-if="resultItem.Content.StaffLocation">
                    Location: <a :href="locationLink + '#' + resultItem.Content.StaffLocation">{{resultItem.Content.StaffLocation}}</a>
                </p>

                <div class="contact">
                    <span class="tel"><a :href="'tel:' + resultItem.Content.StaffPhoneNumber">{{resultItem.Content.StaffPhoneNumber}}</a></span>
                    <a :href="'mailto:' + resultItem.Content.StaffEmailAddress">{{resultItem.Content.StaffEmailAddress}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { truncate } from '@/utils/strings.js'

    export default {
        methods: {
            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        props: {
            locationLink: {
                type: String
            },

            resultItem: {
                required: true,
                type: Object
            }
        }
    }
</script>